import Vue from 'vue';
import store from '../../store';
import types from '@/store/types';

const instance = new Vue();

function getPcToken() {
  let pcToken = '';
  const regResult = /token=(\w+)/ig.exec(window.location.href);
  pcToken = regResult ? regResult[1] : '';
  return pcToken;
}

function getProviderId() {
  let providerId = '';
  const regResult = /code=(\S[^#/]+)/ig.exec(window.location.href);
  providerId = regResult ? regResult[1] : '';
  return window.decodeURIComponent(providerId);
}

export function getUserType() {
  const obj = {
    type: '', // 0:pc,1:供应商,2:手动输入
    pcToken: '',
    providerId: ''
  };

  if (getPcToken() != '') {
    obj.type = 0;
    obj.pcToken = getPcToken();
  } else if (getProviderId() != '') {
    obj.type = 1;
    obj.providerId = getProviderId();
    store.commit(types.UPDATE_ENCRYPTION_ID, obj.providerId); // 保存加密
  } else {
    obj.type = 2;
  }

  return obj;
}

/**
 * 如果无token：
 *  1、如果当前路由不需要token,则直接进入路由页面
 *  2、如果路由需要token
 *    2.1 入口如果是pc (checkUserStatus)
 *      2.1.1 如果是未注册（userstatus:-1）,进入注册页面，只有此情况无token返回
 *      2.1.2 如果是审核中（userstatus:0）,进入审核中页面
 *      2.1.3 如果是审核未通过（userstatus:1）,进入审核未通过页面
 *      2.1.4 如果是审核已完成（userstatus:2）,进入首页
 *    2.2 入口是供应商（checkUserStatus），均无token返回
 *      2.2.1 如果是未注册（userstatus:-1）,进入注册页面
 *      2.2.2 如果是审核中（userstatus:0）,进入审核中页面
 *      2.2.3 如果是审核未通过（userstatus:1）,进入审核未通过
 *      2.2.3 如果是审已完成（userstatus:2）,进入 登录页面
 *    2.3 入口是手动输入url
 *      2.3.1 直接进入登录页
 *   3、 刷新
 */

export const pcEntranceProcess = async function (userType, to, next) {
  // checkstatus

  // -1--->进入注册

  // 0--->注册中，进入编辑第一页
  // 1---审核完成，要先获取用户信息，然后根据路由进入对应页面，如果为/则进入：店首页
  // 2---审核不通过，进入审不通过通知页
  // 4---审核中，进入审核中通知页
  if (store.state.userBrief.status === '') {
    await store.dispatch(types.UPDATE_USER_STATUS_ASYNC, {
      payload: userType.pcToken,
      sourceType: userType.type
    });
    processWithStatus();
  } else {
    processWithStatus();
  }

  async function processWithStatus() {
    const {
      companyStatus
    } = store.state.userBrief;
    switch (companyStatus) {
      case -1: {
        if (to.path === '/') {
          next('/register/enterprise');
        } else {
          next();
        }
        break;
      }
      case 0:
      case 5:
      {
        if (to.path === '/') {
          next('/register/enterprise');
        } else {
          next();
        }
        break;
      }
      case 1: { // 正常,此时是由token的
        if (store.state.userBrief.role === '') {
          await store.dispatch(types.UPDATE_USER_BRIEF_ASYNC);
          if (to.path === '/') {
            next('/index-store');
          } else {
            next();
          }
        } else {
          if (to.path === '/') {
            next('/index-store');
          } else {
            next();
          }
        }
        break;
      }
      case 2: {
        if (to.path === '/') {
          next('/register-audit');
        } else {
          next();
        }
        break;
      }
      case 4: {
        if (to.path === '/') {
          next('/register-audit');
        } else {
          next();
        }
        break;
      }
      default:
        break;
    }
  }
};
export const providerEntranceProcess = async function (userType, to, next) {
  // checkstatus

  // -1-->进入注册
  // 0--->注册中，进入编辑第一页
  // 1---审核完成，从后台进入就进入登录页，其它操作按正常流程供应商首页
  // 2---审核不通过，进入审不通过通知页
  // 4---审核中，进入审核中通知页
  if (store.state.userBrief.status === '') {
    try {
      await store.dispatch(types.UPDATE_USER_STATUS_ASYNC, {
        payload: userType.providerId,
        sourceType: userType.type
      });
      processWithStatus();
    } catch (error) {
      instance.$Notice.error({
        desc: '该供应商不存在'
      });
    }
  } else {
    processWithStatus();
  }

  function processWithStatus() {
    const {
      companyStatus
    } = store.state.userBrief;
    switch (companyStatus) {
      case -1: {
        if (to.path === '/') {
          next('/register/enterprise');
        } else {
          next();
        }
        break;
      }
      case 0: {
        if (to.path === '/') {
          next('/register/enterprise');
        } else {
          next();
        }
        break;
      }
      case 1: { // 正常,此时是由token的    用户刷新也会进入此流程
        if (store.state.userBrief.role === '') { // 表示是从供应商后台进入
          const origin = window.location.href;
          const targetUrl = `${origin.substring(0, origin.indexOf('?'))}#/login`;
          window.location.replace(targetUrl);
        } else {
          if (to.path === '/') {
            next('/index');
          } else {
            next();
          }
        }
        break;
      }
      case 2: {
        if (to.path === '/') {
          next('/register-audit');
        } else {
          next();
        }
        break;
      }
      case 4: {
        if (to.path === '/') {
          next('/register-audit');
        } else {
          next();
        }
        break;
      }
      default:
        break;
    }
  }
};
export const freeEntranceProcess = async function (to, next) {
  if (store.getters.getToken) {
    // get user brief
    // 如果输入首页，则进入登录页；其他页面则获取信息后进入对应页面
    const toLogin = ['/', '/login'];
    const { changeCompanyId } = store.state;
    if (toLogin.includes(to.path)) {
      next('/login');
    } else if (changeCompanyId !== -1) {
      // 切换企业时
      next();
    } else {
      await store.dispatch(types.UPDATE_USER_BRIEF_ASYNC);
      processWithStatus();
    }
  } else {
    next('/login');
  }

  function processWithStatus() {
    next();
  }
};

export default {
  getUserType,
  providerEntranceProcess,
  pcEntranceProcess,
  freeEntranceProcess,
};
